"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[85225],{

/***/ 15253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Widont; }
/* harmony export */ });
function Widont(param) {
    var children = param.children;
    return children.replace(/ ([^ ]+)$/, "\xa0$1");
}


/***/ }),

/***/ 47262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xo": function() { return /* reexport safe */ _components_Widont__WEBPACK_IMPORTED_MODULE_4__.X; },
/* harmony export */   "YS": function() { return /* binding */ Caption; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "qk": function() { return /* binding */ IconContainer; },
/* harmony export */   "y8": function() { return /* binding */ BigText; }
/* harmony export */ });
/* unused harmony exports Link, InlineCode, themeTabs */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46675);
/* harmony import */ var _components_Widont__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15253);





function IconContainer(_param) {
    var tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, color = _param.color, _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as",
        "color",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "w-16 h-16 rounded-full ring-1 ring-gray-900/10 shadow overflow-hidden ".concat(className)
    }, props));
}
function Caption(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mt-2 font-semibold ".concat(className)
    }, props));
}
function BigText(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mt-4 text-3xl sm:text-4xl text-gray-900 font-extrabold tracking-tight ".concat(className)
    }, props));
}
function Paragraph(_param) {
    var tmp = _param.as, Component = tmp === void 0 ? "p" : tmp, _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mt-4 max-w-3xl space-y-6 ".concat(className)
    }, props));
}
function Link(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(Button, _object_spread({
        className: clsx("mt-8", className)
    }, props));
}
function InlineCode(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("code", _object_spread({
        className: "font-mono text-gray-900 font-medium ".concat(className)
    }, props));
}

var themeTabs = {
    Simple: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5 11a4 4 0 0 1 4-4h30a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V11Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0",
                    stroke: "currentColor",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15 7v34",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            ]
        });
    },
    Playful: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5 8h36v32H5V8Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M42 29V11a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h19",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M33.662 41.736a1 1 0 0 1-1.1-1.322l3.08-8.68a1 1 0 0 1 1.736-.274l5.6 7.299a1 1 0 0 1-.637 1.596l-8.679 1.38Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14 7v34",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M22.8 19.949a2 2 0 0 1 2.4-1.5l5.851 1.352a2 2 0 0 1 1.5 2.399l-1.352 5.851a2 2 0 0 1-2.399 1.5l-5.851-1.352a2 2 0 0 1-1.5-2.399l1.352-5.851Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    },
    Elegant: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6 8h32a4 4 0 0 1 4 4v28H6V8Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M43 21v16a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4h20M15 7v34",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M37 7c0 1.101 0 6-6 6 1.101 0 6 0 6 6 0-6 4.899-6 6-6-6 0-6-4.899-6-6ZM31 21c0 .734 0 4-4 4 .734 0 4 0 4 4 0-4 3.266-4 4-4-4 0-4-3.266-4-4Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    },
    Brutalist: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9 41h30a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15 7v34M17 13h-2M43 13h-6",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M21 29V15a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M25 31v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V19a2 2 0 0 0-2-2h-2",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            ]
        });
    }
};


/***/ }),

/***/ 85225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ BlogPostLayout; }
});

// UNUSED EXPORTS: getStaticProps

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./src/components/PostItem.js
var PostItem = __webpack_require__(17782);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/tinytime/dist/tinytime.js
var tinytime = __webpack_require__(4431);
var tinytime_default = /*#__PURE__*/__webpack_require__.n(tinytime);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mdx-js/react/dist/esm.js
var esm = __webpack_require__(3905);
;// CONCATENATED MODULE: ./src/utils/mdxComponents.js


var mdxComponents = {
    img: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative not-prose my-[2em] first:mt-0 last:mb-0 rounded-lg overflow-hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({}, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 rounded-lg ring-1 ring-inset ring-gray-900/10"
                })
            ]
        });
    },
    Footer: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "border-t border-gray-200 mt-8 pt-6",
            children: children
        });
    }
};

// EXTERNAL MODULE: ./src/utils/getAllPosts.js
var utils_getAllPosts = __webpack_require__(11869);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/partials/TradlyFooter.js + 4 modules
var TradlyFooter = __webpack_require__(48777);
;// CONCATENATED MODULE: ./src/layouts/BlogPostLayout.js














var postDateTemplate = tinytime_default()("{dddd}, {MMMM} {DD}, {YYYY}");
var grid = "max-w-3xl mx-auto xl:max-w-none xl:grid xl:grid-cols-[1fr_50rem] xl:gap-x-8";
function BlogPostLayout(param) {
    var children = param.children, meta = param.meta, slug = param.slug, latestPosts = param.latestPosts;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto pt-10 px-4 sm:px-6 md:px-8 xl:px-12 xl:max-w-6xl mt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: (0,clsx_m/* default */.Z)("relative pt-10", grid),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metadata, {
                            meta: meta
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "col-span-full text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:text-center xl:mb-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Widont */.Xo, {
                                children: meta === null || meta === void 0 ? void 0 : meta.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-sm leading-6 mb-16 xl:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden mb-5 pb-5 border-b border-gray-200 xl:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "group flex font-semibold text-gray-700 hover:text-gray-900",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    viewBox: "0 -9 3 24",
                                                    className: "overflow-visible mr-3 text-gray-400 w-auto h-6 group-hover:text-gray-600",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M3 0L0 3L3 6",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                }),
                                                "Go back to blog"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "sr-only",
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "absolute top-0 inset-x-0 text-gray-700 sm:text-center",
                                            children: postDateTemplate.render(new Date(meta.date))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "sm:flex sm:flex-wrap sm:justify-center xl:block",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                    className: "sr-only",
                                                    children: [
                                                        "Author",
                                                        meta.authors.length > 1 && "s"
                                                    ]
                                                }),
                                                meta.authors.map(function(author) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                        className: "flex items-center font-medium mt-6 sm:mx-3 xl:mx-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: author.avatar,
                                                                alt: "",
                                                                className: "mr-3 w-10 h-10 rounded-full bg-gray-50"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-gray-900",
                                                                        children: author.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                        href: "https://twitter.com/".concat(author.twitter),
                                                                        className: "text-color10 hover:text-sky-600",
                                                                        children: [
                                                                            "@",
                                                                            author.twitter
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, author.twitter);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "prose",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MDXProvider */.Zo, {
                                components: mdxComponents,
                                children: children
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: (0,clsx_m/* default */.Z)("mt-14 sm:mt-16", grid),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-start-2 pt-14 sm:pt-16 border-t border-gray-200",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb-10 font-semibold text-gray-900",
                            children: "Latest articles"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-1 gap-y-10 gap-x-8 md:grid-cols-2",
                            children: (latestPosts === null || latestPosts === void 0 ? void 0 : latestPosts.length) > 0 && ((ref = latestPosts === null || latestPosts === void 0 ? void 0 : latestPosts.filter(function(post) {
                                return post.slug !== slug;
                            })) === null || ref === void 0 ? void 0 : ref.map(function(post) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, post), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: post.description
                                    })
                                }), post.slug);
                            }))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-28",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradlyFooter/* default */.Z, {})
            })
        ]
    });
}
function getStaticProps() {
    var ref, ref1;
    return {
        props: {
            latestPosts: getAllPosts().length > 0 && ((ref1 = (ref = getAllPosts()) === null || ref === void 0 ? void 0 : ref.slice(0, 3)) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                var slug = param.slug, meta = param.module.meta;
                return {
                    slug: slug,
                    title: meta === null || meta === void 0 ? void 0 : meta.title,
                    description: meta === null || meta === void 0 ? void 0 : meta.description,
                    date: meta === null || meta === void 0 ? void 0 : meta.date
                } || {};
            }))
        }
    };
}
function Metadata(param) {
    var meta = param.meta;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                children: [
                    meta.title,
                    " – Tradly"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: "@TradlyPlatform"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: "@TradlyPlatform"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: "".concat(meta.title, " – Tradly")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "https://tradly.app".concat(router.pathname)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "article"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: "".concat(meta.title, " – Tradly")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: meta.description
            })
        ]
    });
}


/***/ })

}]);